import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { ServiceGroupsEntityEffects } from './service-groups.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([ServiceGroupsEntityEffects])]
})
export class ServiceGroupEntityModule {}
